


































import { Component, Vue } from "vue-property-decorator";
import { Icon, Button, Field } from "vant";
import navButtons from "@/views/app-pages/components/navButtons.vue";

@Component({
  components: {
    navButtons,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Field.name]: Field
  }
})
export default class Login extends Vue {
  form = {
    id_card: ""
  };

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get isDisabledSubmit() {
    return Object.keys(this.form).some(key => {
      return !this.form[key];
    });
  }

  handleSubmit() {
    (this as any).$apis
      .verifyIdCard(this.form)
      .then(() => {
        this.$router.push("/trade-password-reset");
      })
      .catch(e => {
        
      });
  }
}
